import { BirthdayCard } from "@/components/profile/BirthdayCard";
import { GuestSessionNotice } from "@/components/profile/GuestSessionNotice";
import { MyPrizesCard } from "@/components/marketing/MyPrizesCard";
import { ReferralCard } from "@/components/marketing/ReferralCard";
import { basicInfoAtom, profileAtom } from "@/atoms";
import { ExitIcon, OrderIcon, Pin, ProfileCircleIcon, StarIcon, type IconGlyph } from "@/icons";
import { removeProfileToken } from "@/lib";
import { birthdayEnabled } from "@/consts";
import { useAtomValue } from "jotai";
import { parsePhoneNumberWithError } from "libphonenumber-js";
import { usePageBackground } from "@/hooks/use-page-background";
import { FixedFooter, Heading, Icon, ListRow, PageContainer, Text } from "@/components/ui";

export function ProfileClient() {
  const profile = useAtomValue(profileAtom)
  const basicInfo = useAtomValue(basicInfoAtom)
  usePageBackground()

  if (!profile) return null

  return (
    <PageContainer top="header-gap" bottom="chrome" className="flex flex-col gap-6">
      <Heading level={1} className="sr-only">Minha conta</Heading>
      <div className="flex gap-2">
        <Icon as={ProfileCircleIcon} size="xl" tone="primary" />
        <div>
          <Heading level={2} size="card" weight="normal" tone="muted">{profile.name}</Heading>
          <Text as="span" tone="muted" className="block">
            {parsePhoneNumberWithError(profile.phone.number, 'BR').formatNational()}
          </Text>
        </div>
      </div>
      <GuestSessionNotice />
      <div className="flex flex-col gap-4">
        <LinkCards href="/profile/orders" icon={OrderIcon} text="Pedidos" />
        <LinkCards href="/profile/addresses" icon={Pin} text="Endereços" />
        <LinkCards href="/profile/loyalty" icon={StarIcon} text="Fidelidade" />
      </div>
      <div className="mt-8 flex flex-col gap-4">
        {birthdayEnabled && <BirthdayCard />}
        <MyPrizesCard />
        <ReferralCard storeName={basicInfo?.name} />
      </div>
      <FixedFooter>
        <ListRow
          as="button"
          leading={<Icon as={ExitIcon} size="xl" tone="danger" />}
          title="Sair"
          size="lg"
          titleWeight="semibold"
          trailing="chevron"
          onClick={removeProfileToken}
        />
      </FixedFooter>
    </PageContainer>
  )
}

function LinkCards({ href, icon, text }: { href: string, icon: IconGlyph, text: string }) {
  return (
    <ListRow
      as="link"
      to={href}
      leading={<Icon as={icon} size="xl" tone="primary" />}
      title={text}
      trailing="chevron"
    />
  )
}
